import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://nsuo.fi/portfolio'
      className='link footer__link'
    >
      Nico Suonvieri
    </a>
  </footer>
)

export default Footer
